
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13 3.887l5.526 3.19a2 2 0 011 1.732v6.382a2 2 0 01-1 1.732L13 20.113a2 2 0 01-2 0l-5.526-3.19a2 2 0 01-1-1.732V8.809a2 2 0 011-1.732L11 3.887a2 2 0 012 0zm-3-1.732a4 4 0 014 0l5.526 3.19a4 4 0 012 3.464v6.382a4 4 0 01-2 3.464L14 21.845a4 4 0 01-4 0l-5.526-3.19a4 4 0 01-2-3.464V8.809a4 4 0 012-3.464L10 2.155zM10 12a2 2 0 114 0 2 2 0 01-4 0zm2-4a4 4 0 100 8 4 4 0 000-8z","fill":"currentColor"}})])
          )
        }
      }
    